<div class="a-radiobutton-container" [class.a-radiobutton-disabled]="disabled" [class.a-radiobutton-readonly]="readonly" tabindex="0">
  <div class="a-radiobutton" [class.a-radiobutton-checked]="checked">
    <div class="a-hidden-accessible">
      <input
        #rb
        type="radio"
        [attr.name]="name"
        [attr.value]="value"
        [checked]="checked"
        (change)="onChange()"
        (focus)="onInputFocus()"
        (blur)="onInputBlur()"
        [disabled]="disabled || readonly"
      />
    </div>
    <div (click)="handleClick($event, rb, true)" class="a-radiobutton-box" [class.a-radiobutton-box-focus]="focused">
      <span class="a-radiobutton-icon"></span>
    </div>
  </div>

  <label (click)="select()" class="a-radiobutton-label">
    <!--
      A label can contain a tooltip icon or an image or ...
      To support everything just let the dev-user
      of the component handle it
    -->
    <ng-content></ng-content>
  </label>
</div>
